import { BaseProvider } from "./base.provider";

export interface ServerNode {
  id: string;
  label: string;
  name: string;
  lat: number;
  lng: number;
}

class ShardingProvider extends BaseProvider {
  listServers(): Promise<ServerNode[]> {
    return this.request<ServerNode[]>("/v1/admin/sharding/servers");
  }
}

export const shardingProvider = new ShardingProvider();
